export default __webpack_public_path__ + "static/media/test0.6aa4b5a7.png";